// Re-export api-client types that callers used to get from @/lib/api
export type {
  KundaliRequest,
  DoshaResult,
  PlanetPosition,
  HouseData,
  RashiInfo,
  NumerologyRequest,
  NumberProfile,
  NumberResult,
  NumerologyResponse,
  MuhuratTimePeriod,
  MuhuratPanchangInfo,
  MuhuratVara,
  MuhuratTimeSlot,
  MuhuratResponse,
  PersonInput,
  MatchingRequest,
  KootaResult,
  MangalDoshaResult,
  MatchingPersonSummary,
  PersonDetails,
  MatchingResponse,
  CreditPack,
  PremiumReport,
  Subscription,
  Session,
  PlansResponse,
  ChatBootstrapChart,
  ChatResponseFull,
  CreateOrderResponse,
  InsightResponse,
  TarotCard,
  CalendarFestival,
  CalendarTodayResponse,
  CalendarMonthResponse,
  CalendarUpcomingResponse,
  CityResult,
  NotificationPreferences,
  TodayNotificationsResponse,
} from "@ishvaram/api-client";

// Domain modules
export * from "./kundali";
export * from "./chat";
export * from "./numerology";
export * from "./muhurat";
export * from "./plans";
export * from "./insights";
export * from "./baby-names";
export * from "./remedies";
export * from "./transits";
export * from "./tarot";
export * from "./notifications";
export * from "./calendar";
export * from "./panchang";
export * from "./personas";
export * from "./vastu";
export * from "./misc";
export * from "./kp";
export * from "./explain";
export * from "./kaal-sarp";
